export default {
  title: 'Galleria',
  sections: {
    logo: 'Logo',
    web_images: 'Verkkotilauksen galleriakuvat',
  },
  toasts: {
    image_uploaded: 'Muutokset tallennettiin onnistuneesti',
    image_upload_failed: 'Muutosten tallentaminen epäonnistui',
  },
};
